var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDomaincalculator(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7118 6.90402L26.2181 3.39766C26.7697 2.8461 27.6758 2.87237 28.2537 3.45019L52.9032 28.0998C53.2709 28.4675 53.376 28.9928 53.1921 29.4393C52.2203 31.698 49.5019 38.6582 50.6313 42.7424C52.9689 47.8772 58.931 48.652 61.8989 50.2673C64.8669 51.8826 70.0673 56.4789 71.4068 63.3472C71.9584 67.3394 69.9754 69.283 69.9754 69.283C69.9754 69.283 67.9267 71.3842 63.8294 70.9377C56.8167 69.7689 52.2203 64.5554 50.6576 61.5349C49.0948 58.5145 48.4513 52.4079 43.2378 50.1622C39.0616 49.1248 31.8257 52.119 29.475 53.1827C29.0153 53.3928 28.4638 53.2878 28.1092 52.9332L3.43337 28.2705C2.85554 27.6927 2.85554 26.7471 3.43337 26.1693L15.1475 14.4552L16.0799 13.5228L19.4155 16.8584",
    stroke: "#324A6D",
    strokeWidth: 4.09,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5762 35.3366C11.4298 35.8356 16.6565 40.1168 18.39 37.5954C20.1234 35.074 15.6716 30.123 15.6716 30.123C15.6716 30.123 12.2965 25.3297 14.8179 23.0053C17.3394 20.6808 22.0539 24.3448 22.0539 24.3448C22.0539 24.3448 26.4007 28.5603 27.9898 27.0106C29.5788 25.461 27.4119 21.6264 27.4119 21.6264C27.4119 21.6264 24.6016 17.6341 26.7684 15.4016C28.9353 13.1691 32.8488 15.7562 32.8488 15.7562C32.8488 15.7562 36.0268 17.7917 37.038 16.8724C38.0492 15.9531 35.055 10.3193 35.055 10.3193",
    stroke: "#F7A824",
    strokeWidth: 3.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3965 26.5117L46.8615 22.0598",
    stroke: "#324A6D",
    strokeWidth: 3.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.043 46.8789L37.2503 31.6716",
    stroke: "#324A6D",
    strokeWidth: 3.09091,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3777 62.9537C65.3777 61.8295 64.4664 60.9182 63.3422 60.9182C62.218 60.9182 61.3066 61.8295 61.3066 62.9537C61.3066 64.0779 62.218 64.9893 63.3422 64.9893C64.4664 64.9893 65.3777 64.0779 65.3777 62.9537Z",
    fill: "#324A6D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDomaincalculator);
export default __webpack_public_path__ + "static/media/domain.calculator.dd26b687b39e662ed58d51647ad6f484.svg";
export { ForwardRef as ReactComponent };